import * as React from "react"
import { Center, Flex, Image, SimpleGrid, Stack, Text, useColorModeValue } from "@chakra-ui/react"

export function Partners() {
  const color = useColorModeValue("gray.700", "gray.400")
  return (
    <Center role="region" aria-label="Partners section">
      <Stack spacing={6} alignItems="center">
        <Text 
          fontSize={{ base: 32, md: 48 }} 
          fontWeight={900} 
          lineHeight="shorter" 
          as="h2"
          id="partners-heading"
        >
          Onze partners
        </Text>
        <Text
          px={{ base: 0, md: 48 }}
          color={color}
          fontSize={{ base: "lg", md: "2xl" }}
          lineHeight="short"
          aria-labelledby="partners-heading"
        >
          Kunstbende wordt mogelijk gemaakt door
        </Text>
        <Stack spacing={8} pt={8} aria-label="Partner logos">
          <Flex align="center" justify="center">
            <Image w={{ base: "60%", md: "30%" }} alt="Rabobank partnerlogo" src="/rabo.svg" />
          </Flex>
          <Center>
            <SimpleGrid 
              w={{ base: "70%", md: "60%" }} 
              columns={{ base: 2, md: 3 }} 
              spacing={10}
              role="list"
              aria-label="Additional partner logos"
            >
              <Flex align="center" justify="center" role="listitem">
                <Image alt="FCP partnerlogo" src="/fcp_logo.png" role="img" />
              </Flex>
              <Flex align="center" justify="center" role="listitem">
                <Image alt="ArtEZ partnerlogo" src="/ArtEZ_logo.png" role="img" />
              </Flex>
              <Flex align="center" justify="center" role="listitem">
                <Image alt="CJP partnerlogo" src="/cjp_logo.png" role="img" />
              </Flex>
            </SimpleGrid>
          </Center>
        </Stack>
      </Stack>
    </Center>
  )
}
